import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
  OrdersWithDeliveryStateModel,
  SetVisibleColumns,
} from '@data/orders-with-delivery/orders-with-delivery.actions';

const DEFAULTS: OrdersWithDeliveryStateModel = {
  visibleColumns: [],
};

@State<OrdersWithDeliveryStateModel>({
  name: 'ordersWithDelivery',
  defaults: DEFAULTS,
})
@Injectable()
export class OrdersWithDeliveryState {
  @Selector()
  static visibleColumns(state: OrdersWithDeliveryStateModel): string[] {
    return state.visibleColumns;
  }

  @Action(SetVisibleColumns)
  setVisibleColumns(ctx: StateContext<OrdersWithDeliveryStateModel>, action: SetVisibleColumns): void {
    ctx.patchState({
      visibleColumns: action.columns,
    });
  }
}
